<template>
  <div>
    <div
      class="my-border-radius-top container-padding"
      :class="isDarkSkin ? 'bg-calendar-dark' : 'bg-calendar'"
    >
      <div class="d-flex justify-content-between pt-2">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="ChevronLeftIcon"
            size="35"
            class="cursor-pointer text-primary"
            v-b-tooltip.hover
            @click="previousMonth"
            :title="$t('previous month') | capitalize"
          ></feather-icon>
        </div>

        <div
          class="d-flex align-items-center text-uppercase h2 text-primary font-weight-bolder"
        >
          {{ getNameOfMonth(currentMonth) | capitalize }} - {{ currentYear }}
        </div>

        <div class="d-flex align-items-center">
          <feather-icon
            @click="nextMonth"
            icon="ChevronRightIcon"
            size="35"
            class="cursor-pointer text-primary"
            v-b-tooltip.hover
            :title="$t('next month') | capitalize"
          ></feather-icon>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-1">
        <div>
          <span><span class="legend-driver"></span> {{ $t("Driver") }} </span>
          <span class="ml-2"><span class="legend-rrhh"></span> RRHH </span>
        </div>
        <div class="d-flex">
          <div>
            <v-select
              id="type"
              label="text"
              :options="months"
              :reduce="(val) => val.value"
              v-model="currentMonth"
              :clearable="false"
              class="select-width"
            />
          </div>
          <div class="ml-1">
            <v-select
              v-model="currentYear"
              :options="years"
              :clearable="false"
              class="select-width-year"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
    <div
      class="calendar py-2 my-border-radius-bottom container-padding"
      :class="isDarkSkin ? 'bg-calendar-dark' : 'bg-calendar'"
    >
      <div
        v-for="(name, index) in namesDay"
        class="calendar-header text-center border-left border-right text-white"
        :key="index + name"
      >
        {{ $t(name) }}
      </div>
      <div
        v-for="(day, index) in dayLastMonth"
        :key="index + '_last'"
        :class="
          isDarkSkin ? 'my-border-dark bg-last-dark' : 'my-border-2 bg-last'
        "
      ></div>
      <div
        v-for="(day, index) in attendance"
        class="day text-secondary"
        :key="index"
        :class="isDarkSkin ? 'my-border-dark' : 'my-border-2'"
      >
        {{ day.item }}
        <div
          style="position: relative"
          @click="viewDetail(day)"
          class="cursor-pointer"
        >
          <b-avatar
            rounded
            :variant="resolvColor(day.homework_status_id)"
            :size="iconSize"
            badge-top
            badge-variant="danger"
            badge-offset="-2px"
          >
            <template
              #badge
              v-if="day.comment && day.comment != 'null'"
            ></template>
            <span v-if="day.homework_status_id">
              {{ day.abbreviation }}
            </span>
            <feather-icon v-else icon="AlertTriangleIcon" />
          </b-avatar>
          <span
            v-if="day.driver_comment && day.driver_comment != 'null'"
            class="punto-comment-driver"
          ></span>
          <div
            v-if="day.date === currentDate"
            class="current-day text-success"
            :style="markTodayPostion"
          >
            <feather-icon icon="MapPinIcon" :size="iconMapSize" />
          </div>
        </div>
      </div>
    </div>
    <ModalAttendanceTodayDetail
      v-if="showModalDetail"
      @onlyClose="showModalDetail = false"
      @commentSent="(showModalDetail = false), getAttendanceByEmployee()"
      :dataModal="dataModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import DashboardService from "@/views/driver/views/dashboard/services/dashboard.service.js";
import ModalAttendanceTodayDetail from "@/views/driver/views/dashboard/components/ModalAttendanceTodayDetail.vue";
export default {
  name: "Calendar",

  components: {
    ModalAttendanceTodayDetail,
  },

  computed: {
    ...mapGetters({
      windowWidth: "app/getWindowWidth",
      currentUser: "auth/currentUser",
    }),

    iconSize() {
      if (this.windowWidth < 300) {
        return 23;
      } else {
        return 30;
      }
    },

    iconMapSize() {
      if (this.windowWidth < 700) {
        return "18";
      }
      if (this.windowWidth < 600) {
        return "15";
      }
      if (this.windowWidth < 500) {
        return "12";
      }
      if (this.windowWidth < 300) {
        return "10";
      } else {
        return "25";
      }
    },

    markTodayPostion() {
      if (this.windowWidth > 900) {
        return {
          top: "10%",
          left: "90%",
        };
      }
      if (this.windowWidth > 800) {
        return {
          top: "5%",
          left: "50%",
        };
      }

      if (this.windowWidth > 700) {
        return {
          top: "2px",
          left: "70%",
        };
      }

      if (this.windowWidth > 500) {
        return {
          top: "3px",
          left: "65%",
        };
      } else {
        return {
          top: "1px",
          left: "50%",
          width: "15px",
          height: "15px",
        };
      }
    },

    months() {
      return [
        {
          value: 1,
          text: this.$options.filters.capitalize(this.$t("january")),
        },
        {
          value: 2,
          text: this.$options.filters.capitalize(this.$t("february")),
        },
        { value: 3, text: this.$options.filters.capitalize(this.$t("march")) },
        { value: 4, text: this.$options.filters.capitalize(this.$t("april")) },
        { value: 5, text: this.$options.filters.capitalize(this.$t("may")) },
        { value: 6, text: this.$options.filters.capitalize(this.$t("june")) },
        { value: 7, text: this.$options.filters.capitalize(this.$t("july")) },
        { value: 8, text: this.$options.filters.capitalize(this.$t("august")) },
        {
          value: 9,
          text: this.$options.filters.capitalize(this.$t("september")),
        },
        {
          value: 10,
          text: this.$options.filters.capitalize(this.$t("october")),
        },
        {
          value: 11,
          text: this.$options.filters.capitalize(this.$t("november")),
        },
        {
          value: 12,
          text: this.$options.filters.capitalize(this.$t("december")),
        },
      ];
    },
  },
  data() {
    return {
      showModalDetail: false,
      namesDay: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      daysOfCurrentMonth: [],
      dayLastMonth: [],
      years: [],
      attendance: [],
      dataModal: {},
    };
  },

  methods: {
    getDaysOfMonth() {
      this.daysOfCurrentMonth = [];

      var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
      var lastDay = new Date(this.currentYear, this.currentMonth - 1, 0);

      for (var day = firstDay.getDate(); day <= lastDay.getDate(); day++) {
        var currentDate = new Date(
          this.currentYear,
          this.currentMonth - 1,
          day
        );
        var daysOfMonth = {
          day: day,
          fullDate: moment(currentDate).format("YYYY-MM-DD"),
          key_date: moment(currentDate).format("MM-DD"),
        };
        this.daysOfCurrentMonth.push(daysOfMonth);
      }
    },
    async getAttendanceByEmployee() {
      try {
        this.addPreloader();
        var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
        let date = moment(firstDay).format("YYYY-MM-DD");
        const params = {
          employee_id: this.currentUser.employee_id,
          date: date,
        };
        const { data } = await DashboardService.getAttendanceByEmployee(params);
        const attendances = data.attendance;
        this.attendance = attendances;
      } catch (error) {
        console.log(error);
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
    getDaysLastMonth() {
      this.dayLastMonth = [];

      var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
      var dayWeek = firstDay.getDay();

      if (dayWeek === 0) {
        dayWeek = 7;
      }

      this.dayLastMonth = dayWeek - 1;
    },

    generateLastTenYears() {
      this.years = [];

      for (var i = this.currentYear - 5; i <= this.currentYear + 5; i++) {
        this.years.push(i);
      }
    },

    nextMonth() {
      if (this.currentMonth == 12) {
        this.currentMonth = 1;
      } else {
        this.currentMonth += 1;
      }
    },

    previousMonth() {
      if (this.currentMonth == 1) {
        this.currentMonth = 12;
      } else {
        this.currentMonth -= 1;
      }
    },

    viewDetail(day) {
      if (day.id == null) {
        return;
      }
      this.dataModal = day;
      this.showModalDetail = true;
    },

    resolvColor(homework_status_id) {
      if (homework_status_id == null) return "light-warning";
      switch (homework_status_id) {
        case 1:
          return "light-primary";
          break;
        case 2:
          return "light-success";
          break;
        case 3:
          return "light-danger";
          break;
        default:
          return "light-info";
          break;
      }
    },
  },

  created() {
    this.generateLastTenYears();
    this.getDaysLastMonth();
    this.getDaysOfMonth();
    this.getAttendanceByEmployee();
  },

  watch: {
    currentMonth(oldValue, newValue) {
      if (!newValue) {
        return;
      }

      this.getAttendanceByEmployee();
      this.getDaysLastMonth();
      this.getDaysOfMonth();
    },

    currentYear(oldValue, newValue) {
      if (!newValue) {
        return;
      }
      this.getAttendanceByEmployee();
      this.getDaysLastMonth();
      this.getDaysOfMonth();
    },
  },
};
</script>

<style lang="scss">
.bg-calendar {
  background-color: #ffffff;
}

.bg-calendar-dark {
  background-color: #17171a;
}

.bg-last {
  background-color: #eeeeee;
}

.bg-last-dark {
  background-color: #252529;
}

.my-border-2 {
  border: 1px solid #ececec;
}

.my-border-dark {
  border: 1px solid #444654;
}

.my-border-radius-top {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.my-border-radius-bottom {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

// .container-selects {
//   display: flex;
//   justify-content: end;
//   margin-top: 20px;
//   margin-right: 20px;
// }

.select-width {
  min-width: 130px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 130px;
  }
}

.calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.calendar-header {
  padding: 5px 0 5px 0;
  font-family: "Roboto";
  background-color: #34495e;
}

/* .last-month {
  border: 1px solid black;
} */
.day {
  height: 60px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Roboto";
  font-weight: 400;
}
.current-day {
  width: 20px;
  height: 20px;
  z-index: 9;
  border-radius: 50% 50% 50% 0%;
  animation: growup 0.5s ease-in-out infinite;
  position: absolute;
}
@keyframes growup {
  0% {
    transform: scale(1) translateY(0%);
  }
  50% {
    transform: scale(0.8) translateY(-50%);
  }
  100% {
    transform: scale(1) translateY(0%);
  }
}

@media (min-width: 1001px) and (max-width: 2000px) {
  /* Estilos específicos para pantallas con un ancho máximo de 600px */
  .container-padding {
    padding: 0 20px;
  }
}

@media (min-width: 601px) and (max-width: 1000px) {
  /* Estilos específicos para pantallas con un ancho máximo de 600px */
  .container-padding {
    padding: 0 20px;
  }
}

@media (max-width: 600px) {
  /* Estilos específicos para pantallas con un ancho máximo de 600px */
  .container-padding {
    padding: 0 5px;
  }
  .container-selects {
    justify-content: center;
    margin-right: 0;
  }

  .select-width-year {
    min-width: 80px;

    ::v-deep .vs__selected {
      width: 50px;
    }
  }

  .select-width {
    min-width: 100px;

    ::v-deep .vs__selected {
      width: 80px;
    }
  }
}

.punto-comment-driver {
  position: absolute;
  display: inline-block; /* Esto hace que el span se comporte como un elemento en línea con dimensiones */
  width: 13px; /* Define el ancho del punto */
  height: 13px; /* Define la altura del punto */
  top: -2px;
  left: -5px;
  background-color: rgba(59, 124, 245, 0.72); /* Establece el color rojo */
  border-radius: 50%; /* Hace que el punto sea redondo ajustando el radio del borde */
}

.legend-driver {
  display: inline-block; /* Esto hace que el span se comporte como un elemento en línea con dimensiones */
  width: 13px; /* Define el ancho del punto */
  height: 13px; /* Define la altura del punto */
  background-color: rgba(59, 124, 245, 0.72); /* Establece el color rojo */
  border-radius: 50%; /* Hace que el punto sea redondo ajustando el radio del borde */
}

.legend-rrhh {
  display: inline-block; /* Esto hace que el span se comporte como un elemento en línea con dimensiones */
  width: 13px; /* Define el ancho del punto */
  height: 13px; /* Define la altura del punto */
  background-color: rgba(232, 21, 21, 0.72); /* Establece el color rojo */
  border-radius: 50%; /* Hace que el punto sea redondo ajustando el radio del borde */
}
</style>